var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "choice-cards" },
    _vm._l(_vm.options, function (option) {
      return _c(
        "button",
        {
          key: String(option.value),
          staticClass: "choice-card",
          class: {
            "is-selected": option.value === _vm.value,
            "is-disabled": _vm.disabled,
          },
          attrs: { type: "button", disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.$emit("input", option.value)
            },
          },
        },
        [
          _c(
            "span",
            { staticClass: "choice-card-head" },
            [
              _c(
                "span",
                { staticClass: "choice-card-icon" },
                [
                  _c("feather-icon", {
                    attrs: {
                      icon: option.icon || "CircleIcon",
                      svgClasses: "w-5 h-5",
                    },
                  }),
                ],
                1
              ),
              _c("span", { staticClass: "choice-card-title" }, [
                _vm._v(_vm._s(option.title)),
              ]),
              option.value === _vm.value
                ? _c("feather-icon", {
                    staticClass: "choice-card-check",
                    attrs: { icon: "CheckCircleIcon", svgClasses: "w-5 h-5" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("small", { staticClass: "choice-card-description" }, [
            _vm._v(_vm._s(option.description)),
          ]),
          option.example
            ? _c("small", { staticClass: "choice-card-example" }, [
                _vm._v(_vm._s(option.example)),
              ])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }